import * as actionTypes from '../store/action';

const initialState = {
    token: "",
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.TOKEN:
            return {
                ...state,
                token: action.token
            }
        default:
            return state;
    }
}

export default reducer;